import { Component, EventEmitter, Input, OnChanges, OnInit, Output, } from "@angular/core";
import { FormGroup,  FormBuilder, Validators, FormArray } from "@angular/forms";
import { AdminService } from "../../../../services/admin.service";
import { apiUrl } from "../../../../global/global";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-step-four",
  templateUrl: "./step-four.component.html",
  styleUrls: ["./step-four.component.css"]
})
export class StepFourComponent implements OnInit {
  isStepper;
  @Input() filledData: any;
  @Input() isAdd: any;
  @Output() valueChange = new EventEmitter();
  @Output() stepperChange = new EventEmitter();
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  objectProp: any;
  // form
  form: FormGroup;
  showError: boolean = false;  
  allQuestions:any=[];
  selectedValue = 0;
  addedQuestion:any=[];
  constructor( private formBuilder: FormBuilder, private api: AdminService, private toastrService: ToastrService){
    this.form = this.formBuilder.group({ 
      id: [""],
      steps: [""],
      addCustomQuestion: formBuilder.array([]) 
    })
  }
  // add new address
addCustomeQuestion() : FormGroup {
  return this.formBuilder.group({
    title : "",
    skillName : "",
    experience: "",
    responseType: "",
    answer:"", 
  })
}
getCusQuestion() {
  return (this.form.get('addCustomQuestion') as FormArray).controls;
}
// host list
addMoreQuestion(){ 
  (this.form.controls['addCustomQuestion'] as FormArray).push(this.addCustomeQuestion()) 
}
deleteQuestion(i){
  (this.form.controls['addCustomQuestion'] as FormArray).removeAt(i);
}
  back() {
    this.stepperChange.emit({ step : 3 });
  }
  
  ngOnChanges(filledData: any) {
   if(filledData != undefined){
      this.filledData = filledData.filledData.currentValue;
      this.getselectedQuestion();
      this.form.patchValue({
        ...this.filledData?.JobPost,
        id:this.filledData?.JobPost?.id
      })
    } 
  }
  changeResponse(event,i){
    if(event == 1){
      (this.form.get('addCustomQuestion') as FormArray).controls[i].patchValue({
        answer: ""
      });
    }
    
  }
  getselectedQuestion(){
    if (this.allQuestions.length > 0 && this.filledData != undefined){
      this.allQuestions.map((ques)=> {
        this.filledData.JobPostAddQuestions.map((postQ) => {
          if(ques.id == postQ.addScreeningQuestionId) {
            ques['selected'] = true;
          }
        }) 
      })
    } 
  }
  ngOnInit(): void {  
    (this.form.controls['addCustomQuestion'] as FormArray).push(this.addCustomeQuestion())  
    this.getQuestion();
  }
  getQuestion(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getQuestions)
    .subscribe(async (res) => {
      this.allQuestions = res.data.data;
      this.getselectedQuestion();
     })
  }
  
  selectedQuestion(i,event){
    if (this.allQuestions[i]["selected"] == true) {
      this.allQuestions[i]["selected"] = false
      event.srcElement.classList.remove("selected") 
    } else {
      this.allQuestions[i]["selected"] = true
      event.srcElement.classList.add("selected") 
    }
  }
  addQuestion(){ 
    let questions:any=[];
    this.allQuestions.map((ques)=>{  
      if (ques["customeQuestion"] == true){ 
      this.addedQuestion.push({"addScreeningQuestionId":ques.id,"title":ques.title,"experience":"0","responseType":ques.responseType,"answer":ques.answer})
      }
    }) 
      if(this.form.value.addCustomQuestion != null && this.form.value.addCustomQuestion.length > 0){
        this.form.value.addCustomQuestion.map((ques)=> {
        if(ques.title == null || ques.title == ''){
          this.showError = true;
          setTimeout(() => {
            this.showError = false
          }, 2000);
          return
        } else{
          this.addedQuestion.push(ques);
        }
        })
        // return
      } 
      this.deleteQuestion(0); 
  }
  deleteQues(i){
    this.addedQuestion.splice(i,1)
  }
  // on submit
  onSubmit(){ 
    let questions:any=[];
    this.allQuestions.map((ques)=>{  
      if (ques["selected"] == true){
        questions.push({"addScreeningQuestionId":ques.id,"title":ques.title,"experience":"0","responseType":ques.responseType,"answer":ques.answer})
      }
    }) 
      if(this.addedQuestion.length > 0){
        this.addedQuestion.map((ques)=> {
          questions.push(ques);
        })
      } 
    const data={ 
      id:this.filledData?.JobPost?.id,
      steps:4,
      addCustomQuestion: questions
    } 
    if(this.form.valid){
      this.api.putData(apiUrl._getJobs, data)
      .subscribe(async (res) => { 
        this.valueChange.emit({ data: res.data.result.payload });
      })
      
    } else{
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 2000);
    }
  }
  
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
}
